import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

import { calculateFields } from './calculateFields'
import { getFieldsWithCurrencyAndValueType } from './getFieldsWithCurrencyAndValueType'
import { getSellThruField } from './getSellThruField'

interface IGetUpdateItemWithCalculatedRowFields {
  field: string
  value: number
  hpItem?: ISobCompetitor
}
export const getCalculatedFieldsForField = ({
  hpItem,
  field,
  value,
}: IGetUpdateItemWithCalculatedRowFields) => {
  const sellThruField = getSellThruField(field)
  const fieldsToChange = getFieldsWithCurrencyAndValueType(sellThruField)
  return calculateFields({ fields: fieldsToChange, hpItem, field, value })
}
